<template>
  <v-container
    fluid
    class="fill-height pa-0"
  >
    <!-- <v-row
      v-if="isLoading"
      justify="center"
      align="center"
      class="fill-height ma-0 black"
    >
      <v-progress-linear
        color="warning"
        top
        absolute
        :value="this.loadingProgress"
      />
      <span class="body-1 loading-text">{{loadingMessage}}</span>
    </v-row> -->
    <v-row
      class="fill-height ma-0"
    >
      <!-- <canvas id="canvas" class="fill-height full-width"/> -->
      <iframe 
        class="fill-height full-width" 
        scrolling="no" 
        title="Mappa" 
        frameborder="0" 
        :src="urlProcessing"
        v-if="!this.isLoading"
        style="padding-left: 350px !important;">        
      </iframe>      
    </v-row>
  </v-container>
</template>

<script>
  import {MapViewEventBus} from "../../helpers/mapview/events"
  import {ENVIRONMENT} from "./../../globals"

  const _Processing = Symbol.for("_Processing")

  export default {
    name: "Map3DPotree",
    inject: {_Processing},
    data: () => ({
      isInitialized: false,
      isLoading: true,
      loadingProgress: 0,
      loadingMessage: "",
      urlProcessing: "",
    }),
    methods: {
      async onMounted() {
        const env = `${ENVIRONMENT}`
        if (env == 'production'){
          this.urlProcessing = "https://proc3d.mappa.ag?r=https://api.mappa.ag/v1/projects/processings/"+this.Processing["id_processing"]+"/3d-entwine-pointcloud/ept.json"
        } else {
          this.urlProcessing = "https://proc3d.mappa.ag?r=https://api.dev.mappa.ag/v1/projects/processings/"+this.Processing["id_processing"]+"/3d-entwine-pointcloud/ept.json"
        }
        this.loadingProgress = 0
        this.loadingMessage = "Carregando nuvem de pontos..."
        this.isLoading = false
      },
    },
    computed: {
      Processing() {
        return this._Processing()
      }
    },
    created() {
      MapViewEventBus.$on("map-3d-open", this.onMounted)
    }
  }
</script>

<style scoped lang="scss">
  .full-width {
    width: 100%;
  }

  .loading-text {
    color: #FFFFFF !important;
  }
</style>
